export class GlobalVars {
  public static readonly SERVER_ENDPOINT =
    process.env.REACT_APP_BACKEND_URL ??
    "https://popup-server.azurewebsites.net";

  public static readonly MOBILE_SCREEN_WIDTH = 768;
}
